/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as PillarIndexRouteImport } from "./routes/$pillar.index";
import { Route as PillarCategoryIndexRouteImport } from "./routes/$pillar.$category.index";
import { Route as PillarCategoryInitiativeIndexRouteImport } from "./routes/$pillar.$category.$initiative.index";

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const PillarIndexRoute = PillarIndexRouteImport.update({
  id: "/$pillar/",
  path: "/$pillar/",
  getParentRoute: () => rootRouteImport,
} as any);
const PillarCategoryIndexRoute = PillarCategoryIndexRouteImport.update({
  id: "/$pillar/$category/",
  path: "/$pillar/$category/",
  getParentRoute: () => rootRouteImport,
} as any);
const PillarCategoryInitiativeIndexRoute =
  PillarCategoryInitiativeIndexRouteImport.update({
    id: "/$pillar/$category/$initiative/",
    path: "/$pillar/$category/$initiative/",
    getParentRoute: () => rootRouteImport,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/$pillar/": typeof PillarIndexRoute;
  "/$pillar/$category/": typeof PillarCategoryIndexRoute;
  "/$pillar/$category/$initiative/": typeof PillarCategoryInitiativeIndexRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/$pillar": typeof PillarIndexRoute;
  "/$pillar/$category": typeof PillarCategoryIndexRoute;
  "/$pillar/$category/$initiative": typeof PillarCategoryInitiativeIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/$pillar/": typeof PillarIndexRoute;
  "/$pillar/$category/": typeof PillarCategoryIndexRoute;
  "/$pillar/$category/$initiative/": typeof PillarCategoryInitiativeIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/$pillar/"
    | "/$pillar/$category/"
    | "/$pillar/$category/$initiative/";
  fileRoutesByTo: FileRoutesByTo;
  to:
    "/" | "/$pillar" | "/$pillar/$category" | "/$pillar/$category/$initiative";
  id:
    | "__root__"
    | "/"
    | "/$pillar/"
    | "/$pillar/$category/"
    | "/$pillar/$category/$initiative/";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  PillarIndexRoute: typeof PillarIndexRoute;
  PillarCategoryIndexRoute: typeof PillarCategoryIndexRoute;
  PillarCategoryInitiativeIndexRoute: typeof PillarCategoryInitiativeIndexRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/$pillar/": {
      id: "/$pillar/";
      path: "/$pillar";
      fullPath: "/$pillar/";
      preLoaderRoute: typeof PillarIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/$pillar/$category/": {
      id: "/$pillar/$category/";
      path: "/$pillar/$category";
      fullPath: "/$pillar/$category/";
      preLoaderRoute: typeof PillarCategoryIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/$pillar/$category/$initiative/": {
      id: "/$pillar/$category/$initiative/";
      path: "/$pillar/$category/$initiative";
      fullPath: "/$pillar/$category/$initiative/";
      preLoaderRoute: typeof PillarCategoryInitiativeIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  PillarIndexRoute: PillarIndexRoute,
  PillarCategoryIndexRoute: PillarCategoryIndexRoute,
  PillarCategoryInitiativeIndexRoute: PillarCategoryInitiativeIndexRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
